/** Keluar dari aplikasi: konfirmasi, bersihkan token/cache, lalu ke /login. Dipakai Sidebar & AppTopBar. */
export function logoutWithConfirm() {
    if (!confirm("Apakah Anda yakin ingin keluar?")) return;
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    // Clear permission cache (semua varian key: per-level lama & per-user baru)
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
        const k = sessionStorage.key(i);
        if (k && k.startsWith("_menuPerms")) sessionStorage.removeItem(k);
    }
    // Clear plan-gating cache (paket bisa berbeda antar tenant/login)
    sessionStorage.removeItem("_planMenus");
    document.cookie = "token=; path=/; max-age=0; SameSite=Strict";
    window.location.href = "/login";
}
